function getVerticalPaddingByDensity(density) {
  switch (density) {
    case "comfortable":
      return 1.5;
    case "normal":
      return 1;
    case "compact":
      return 0;
  }
}
export {
  getVerticalPaddingByDensity
};
//# sourceMappingURL=getVerticalPaddingByDensity.js.map
